import type { TOC } from '@ember/component/template-only';

import GenieRoutinesComponent from 'webapp/components/genie/routines/index';

const RoutinesIndexRouteTemplate: TOC<object> = <template><GenieRoutinesComponent /></template>;

export default RoutinesIndexRouteTemplate;
